import './style.css';
import { InputField } from '@/components/Exporter';
import SectionWrapper from '../shared/SectionWrapper';

const ContactDetails = ({ formHandler }) =>
    <SectionWrapper name="contact-details" icon="teenyicons:contact-solid" >
        <InputField lang="any" isLoading={false} name="email" type="email" formHandler={formHandler} />
        <InputField lang="any" isLoading={false} name="phoneNumber" formHandler={formHandler} />
    </SectionWrapper>

export default ContactDetails

